var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "modal",
      staticClass: "online-full-screen-modal",
      attrs: {
        id: "annonce-online-modal",
        "header-class": "online-modal-header",
        centered: "",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        "ok-variant": "primary"
      },
      on: { ok: _vm.handleOk },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function(ref) {
            var close = ref.close
            return [
              _c(
                "div",
                { staticClass: "online-modal-header-content step4 w-100" },
                [
                  _c("img", {
                    staticClass: "online-modal-img",
                    attrs: {
                      src: require("@/assets/images/b122/img-perso-ok.png")
                    }
                  }),
                  _vm._v(" "),
                  _c("div", { staticClass: "online-container h-100" }, [
                    _c(
                      "h1",
                      {
                        staticClass:
                          "page-title mt-4 ml-4 online-modal-subtitle"
                      },
                      [_vm._v(_vm._s(_vm.$t(_vm.getModalTitle())))]
                    )
                  ])
                ]
              )
            ]
          }
        },
        {
          key: "modal-footer",
          fn: function(ref) {
            var ok = ref.ok
            var cancel = ref.cancel
            var hide = ref.hide
            return [
              _c(
                "div",
                { staticClass: "w-100 d-flex" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "w-100",
                      attrs: { variant: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.handleOk($event)
                        }
                      }
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-center" },
                        [
                          _c(
                            "span",
                            { staticClass: "align-self-center mt-small-px" },
                            [_vm._v(_vm._s(_vm.$t("Continue")))]
                          )
                        ]
                      )
                    ]
                  )
                ],
                1
              )
            ]
          }
        }
      ])
    },
    [
      _vm._v(" "),
      _c("div", [
        _c("p", {
          staticClass: "modal-annonce-text mt-2",
          domProps: { innerHTML: _vm._s(_vm.$t(_vm.getModalContent())) }
        }),
        _vm._v(" "),
        _c("p", {
          staticClass: "modal-annonce-text-offline",
          domProps: {
            innerHTML: _vm._s(_vm.$t("payment_successful_dialog_reminder"))
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b9f59d5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b9f59d5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/annonce/AnnonceOnlineModal.vue
// module id = ujoi
// module chunks = 0